import React, { Component, ReactFragment } from "react";
import { RouteComponentProps } from "react-router";
import { Button, Typography } from "@material-ui/core";
import DefaultLayout from "layouts/Default";
import NextRouteURLs from "NextRouteURLs";
import { Space } from "services/entities/spaces";
import "./index.scss";
import { loadSpaces } from "services/spaces";
import SpacesFilterHeader from "../../../components/SpacesFilterHeader";
import BookingEnquiryForm from "../../../components/bookings/BookingEnquiryForm";
import SpaceTile from "../../../components/spaceTile";

interface ListSpacesPageState {
  spaces: Space[] | null;
  windowSize: number;
  activatedFilters: string[];
}

export default class ListSpacesPage extends Component<
  RouteComponentProps,
  ListSpacesPageState
> {
  state: ListSpacesPageState = {
    spaces: null,
    windowSize: window.innerWidth,
    activatedFilters: [],
  };

  componentDidMount(): void {
    window.addEventListener("resize", this.handleResize);
    loadSpaces().then((spaces) => this.setState({ spaces: spaces }));
  }

  handleResize = (): void => {
    this.setState({ windowSize: window.innerWidth });
  };

  deactivateFilter = (location: string): void => {
    const newFilters = this.state.activatedFilters.filter(
      (val) => val !== location
    );
    this.setState({ activatedFilters: newFilters });
  };

  activateFilter = (location: string): void => {
    this.setState({
      activatedFilters: [...this.state.activatedFilters, location],
    });
  };

  filterList = (location: string): void => {
    if (this.state.activatedFilters.includes(location)) {
      this.deactivateFilter(location);
    } else {
      this.activateFilter(location);
    }
  };

  onContactClick = (): void => {
    window.location.href = NextRouteURLs.CONTACT
  };

  isInFilter = (space: Space): boolean => {
    const city = space.city;
    if (
      (city && this.state.activatedFilters?.includes(city)) ||
      !this.state.activatedFilters ||
      this.state.activatedFilters.length === 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  renderSpaceItem = (space: Space, index: number): ReactFragment => {
    if (this.isInFilter(space)) {
      return (
        <div key={index} className="space-item">
          <SpaceTile key={space.code} space={space} variant="compact" />
        </div>
      );
    } else {
      return <></>;
    }
  };

  render() {
    const spaces = this.state.spaces;
    return (
      <DefaultLayout id="list-spaces-page">
        {this.state.windowSize <= 800 && (
          <div
            className="top"
            style={{ position: "relative", height: "100px" }}
          ></div>
        )}
        <BookingEnquiryForm />
        <div className="outer-wrapper">
          <SpacesFilterHeader
            code="textMedia"
            filterList={this.filterList}
            spaces={spaces}
            filters={this.state.activatedFilters}
          />
        </div>
        <section className="content-mw section--spaces">
          <div className="section-space-tiles">
            {spaces && spaces.map(this.renderSpaceItem)}
          </div>
        </section>
        <section className="content-mw  section--title-text-link">
          <div className="inner">
            <Typography className="title" variant="h2" component="h3">
              Don’t see a space
              <br /> that suits your needs?
            </Typography>
            <Typography className="text" variant="body1" component="div">
              Let us know what you are after, as we are always trying to expand
              our options for spaces available to our tenants.
            </Typography>
          </div>
          <Button
            className="spaces-link"
            variant="contained"
            onClick={this.onContactClick}
          >
            Tell us
          </Button>
        </section>
      </DefaultLayout>
    );
  }
}
